import React, { useState } from 'react';
import { Transition } from '@headlessui/react'
import { classNames } from '../../../Services/helpers';
import AlertBadge from '../../Icons/AlertBadge';

const Accordion = ({children}) => {
    const [openPanel, setOpenPanel] = useState(null);

    return <div>
        {children.map((panel, index) => {
            const isOpen = openPanel === index;
            const isFirst = (index === 0) || (openPanel !== null && index === openPanel + 1);
            const isLast = (index === children.length - 1) || (openPanel !== null && index === openPanel - 1);

            return <div key={index}
                className={classNames(
                    isOpen && 'rounded-md border my-2',
                    'border-l border-r',
                    isFirst && 'border-t rounded-t-md',
                    (!isFirst && !isOpen) && 'border-t -mt-px',
                    isLast && 'border-b rounded-b-md',
                )}
            >
                <button onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpenPanel(isOpen ? null : index)}}
                    className={classNames(
                        'w-full p-2 flex flex-row hover:bg-slate-100',
                        isOpen && 'bg-slate-100 text-brand font-bold',
                        !isOpen && 'hover:text-brand',
                    )}
                >
                    <span className="grow text-left">{panel.props.title}</span>
                    <AlertBadge icon={isOpen ? 'UpChevron' : 'DownChevron'}
                        size="small"
                        theme={isOpen ? 'brand' : 'info'}
                    />
                </button>

                <Transition
                    show={isOpen}
                    enter="transition-[max-height] transition-opacity duration-500 overflow-hidden"
                    enterFrom="opacity-0 max-h-[0px]"
                    enterTo="opacity-100 max-h-[1000px]"
                    leave="transition-[max-height] transition-opacity duration-500 overflow-hidden"
                    leaveFrom="opacity-100 max-h-[1000px]"
                    leaveTo="opacity-0 max-h-[0px]"
                >
                    {panel}
                </Transition>
            </div>
        })}
    </div>
}

const Panel = ({children}) => {
    return <div className="p-2">
        {children}
    </div>
}

export default Accordion;

export {
    Panel
}
